import { BrowserRouter } from 'react-router-dom';
import AuthProvider from './contexts/AuthContext';
import FilterProvider from './contexts/FilterContext';
import MensagemProvider from './contexts/MensagemContext';
import Routes from './routes';
import React from 'react';

import 'quill/dist/quill.snow.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import './layout/flags/flags.css';
import './layout/layout.scss';

function App() {

  return (
    <AuthProvider>
      <FilterProvider>
        <MensagemProvider>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </MensagemProvider>
      </FilterProvider>
    </AuthProvider>
  );
}

export default App;
